import { css } from "styled-components";

export const DialogStyles = css`
    .dit-components-dialog-content.dit-components-dialog-alert-content .dialog-warning-icon {
        width: 1.5rem;
        grid-column: 1;
        grid-row: 1;
        align-content: center;
        color: var(--dit-brand-color-status-warning-50--map);
        .icon {
            font-size: 1.5rem;
            padding: 0;
        }
    }
    .dit-components-dialog-alert-content.dit-components-dialog-alert-icon {
        color: var(--dit-brand-color-status-alert-50--map);
        .icon {
            font-size: 1.5rem;
        }
    }

    .modal-close-button {
        & svg {
            fill: var(--dit-layout-color-dialog-close--map);
        }
    }

    &.modal-close-button-md svg {
        height: 1rem;
        width: 1rem;
    }
    &.modal-close-button-sm svg {
        height: 1.25rem;
        width: 1.25rem;
    }
    .dit-components-dialog-body .modal-error-description-list {
        gap: 0;
        ul {
            padding-left: 1.5rem;
        }
        li {
            display: list-item;
            list-style-type: disc;
        }
    }

    .dit-components-dialog-footer .error-type {
        color: var(--dit-brand-color-neutral-65--map);
    }

    .dit-components-dialog-content.scrollable-body {
        grid-template-rows: auto 1fr auto;
        max-height: 80vh;
        bottom: 5vh;

        .dit-components-dialog-body {
            overflow-y: auto;
        }
    }
`;
